import Vue from "vue";
import { applicationLocales } from "@/common/config";

export const DEFAULT_LANG = "en-US";

// add translations directly to the application
loadDefaultLanguage();

async function loadLanguageFile(lang) {
  return await import(/* webpackMode: "lazy", webpackChunkName: "i18n" */ `@/lang/${lang}.json`);
}

/*
 * Get list of languages
 * @return Array [{ id: en-US, icon: "/images/flags/en-US.png"}, ...]
 */
export function getLanguages() {
  const languages = (applicationLocales || []).map(id => {
    return {
      id,
      icon: require(`@/assets/images/flags/${id}.png`)
    };
  });

  return languages;
}

/*
 * Return short lang from e.g. en-US -> en
 */
export function shortLang(lang) {
  return lang && lang.indexOf("-") > -1 ? lang.split("-")[0] : "en";
}

export function loadFlatpickrLanguage(lang) {
  const fileName = lang === "en-US" || !lang ? "default" : shortLang(lang);
  const file = require(`flatpickr/dist/l10n/${fileName}.js`);
  return file && ((file.default && file.default[fileName]) || file.default);
}

/*
 * Get list of languages
 * param flags Array (es. ["./it.json",...])
 */
export function findLanguage(lang) {
  const defaultFind = {
    id: DEFAULT_LANG,
    icon: require(`@/assets/images/flags/${DEFAULT_LANG}.png`)
  };

  const find = getLanguages().find(item => item.id === lang);
  return find || defaultFind;
}

export async function loadDefaultLanguage() {
  let result = DEFAULT_LANG;
  try {
    const msgs = await loadLanguageFile(DEFAULT_LANG);
    Vue.i18n.add(DEFAULT_LANG, { ...msgs });
    Vue.i18n.set(DEFAULT_LANG);
    Vue.i18n.fallback(DEFAULT_LANG);
  } catch (e) {
    result = null;
  }

  return result;
}
// set the start locale to use
export default async function setLanguage(lang) {
  let result = lang ?? DEFAULT_LANG;

  try {
    const msgs = await loadLanguageFile(lang);

    Vue.i18n.add(lang, { ...msgs });
    Vue.i18n.set(lang);
  } catch (e) {
    result = await loadDefaultLanguage(DEFAULT_LANG);
  }

  return result;
}
